export default {
  MAX_TEMP : '80',
  MIN_TEMP : '20'
};



// WEBPACK FOOTER //
// ./src/components/enum/cool_unit_temp.js